import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Repo from "./Utility/Repo";
import Spinner from "react-bootstrap/Spinner";

function ModalDelete(props) {
  const [loading, setLoading] = React.useState(false);

  const [tempData, setTempoData] = useState({
    parent: null,
    intent: null,
    phrases: [],
    answers: [],
    chips: [],
    endConv: props.itemsForDelete ? props.itemsForDelete.endConv : false,
  });

  const handleSubmite = () => {
    var obbj = {
      intentId: tempData.id,
      projectId: props.projectId,
      displayName: props.itemsForDelete.intent,
    };

    Repo.deleteIntents(JSON.stringify(obbj))
      .then(function (response) {
        props.eventShow(false);

        setLoading(true);

        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (props.itemsForDelete) {
      setTempoData(props.itemsForDelete);
    }
  }, [props.itemsForDelete]);

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => props.onHide(false)}
        aria-labelledby="contained-modal-title-vcenter"
        animation={true}
        centered={true}
        size={"xl"}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Eliminazione
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          L’operazione non è reversibile, sicuro di voler procedere?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            type="submit"
            onClick={() => handleSubmite()}
          >
            Si
          </Button>

          <Button variant="danger" onClick={props.onHide}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      {loading && (
        <div className="spinnerClass">
          <Spinner
            animation="grow"
            variant="light"
            style={{ width: "70px", height: "70px" }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
}

export default ModalDelete;
